import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class EditIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path d="M9.818 1.475L8.525.182a.62.62 0 0 0-.719-.115.057.057 0 0 0-.058.013L1.513 6.315l-.695.695a.059.059 0 0 0-.016.03l-.007-.007L0 10l2.967-.795-.008-.008a.059.059 0 0 0 .031-.015l6.93-6.93a.057.057 0 0 0 .014-.059.621.621 0 0 0-.116-.718z"/></svg>
        )
    }
}

export default withCssClassName(EditIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/edit-icon.js